"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralTopics = exports.ScreenName = exports.ScreenType = exports.ProgressCardsType = exports.CardStatus = void 0;
var CardStatus;
(function (CardStatus) {
    CardStatus["COMPLETED"] = "COMPLETED";
    CardStatus["PENDING"] = "PENDING";
    CardStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CardStatus["ALL_COMPLETED"] = "ALL_COMPLETED";
    CardStatus["EXPIRED"] = "EXPIRED";
})(CardStatus = exports.CardStatus || (exports.CardStatus = {}));
var ProgressCardsType;
(function (ProgressCardsType) {
    ProgressCardsType[ProgressCardsType["SIGNUP"] = 21004] = "SIGNUP";
    ProgressCardsType[ProgressCardsType["GAMEPLAY_COUNT"] = 21005] = "GAMEPLAY_COUNT";
    ProgressCardsType[ProgressCardsType["GAMEPLAY_DAYS"] = 21006] = "GAMEPLAY_DAYS";
    ProgressCardsType[ProgressCardsType["DEPOSIT1"] = 21001] = "DEPOSIT1";
    ProgressCardsType[ProgressCardsType["DEPOSIT2"] = 21002] = "DEPOSIT2";
    ProgressCardsType[ProgressCardsType["DEPOSIT3"] = 21003] = "DEPOSIT3";
})(ProgressCardsType = exports.ProgressCardsType || (exports.ProgressCardsType = {}));
var ScreenType;
(function (ScreenType) {
    ScreenType["IN_APP"] = "IN_APP";
    ScreenType["DEEP_LINK"] = "DEEP_LINK";
    ScreenType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    ScreenType["WEBVIEW_LINK"] = "WEBVIEW_LINK";
})(ScreenType = exports.ScreenType || (exports.ScreenType = {}));
var ScreenName;
(function (ScreenName) {
    ScreenName["REFER"] = "REFER";
    ScreenName["SETTINGS"] = "SETTINGS";
    ScreenName["PLAY_ONLINE"] = "PLAY_ONLINE";
    ScreenName["NOTIFICATION"] = "NOTIFICATION";
    ScreenName["PROFILE"] = "PROFILE";
    ScreenName["PWF"] = "PWF";
    ScreenName["HELPDESK"] = "HELPDESK";
    ScreenName["WALLET"] = "WALLET";
    ScreenName["MTT_TOURNAMENT"] = "MTT_TOURNAMENT";
    ScreenName["CONTEST"] = "CONTEST";
    ScreenName["NUDGE"] = "NUDGE";
    ScreenName["HOW_TO_PLAY"] = "HOW_TO_PLAY";
    ScreenName["TELEGRAM_REFERRAL"] = "TELEGRAM_REFERRAL";
    ScreenName["WHATSAPP_SHARE"] = "WHATSAPP_SHARE";
    ScreenName["KYC"] = "KYC";
    ScreenName["DAILY_CHALLENGE"] = "DAILY_CHALLENGE";
    ScreenName["APP_RESTART"] = "APP_RESTART";
    ScreenName["ADD_BANK"] = "ADD_BANK";
    ScreenName["ADD_UPI"] = "ADD_UPI";
    ScreenName["ADD_MONEY"] = "ADD_MONEY";
    ScreenName["DASHBOARD"] = "DASHBOARD";
    ScreenName["WITHDRAWAL"] = "WITHDRAWAL";
})(ScreenName = exports.ScreenName || (exports.ScreenName = {}));
var ReferralTopics;
(function (ReferralTopics) {
    ReferralTopics["ReferralLimitOfUser"] = "ReferralLimitOfUser";
    ReferralTopics["ReferralShareResources"] = "ReferralShareResources";
    ReferralTopics["ReferralRewardConfigFirstDeposit"] = "ReferralRewardConfigFirstDeposit";
})(ReferralTopics = exports.ReferralTopics || (exports.ReferralTopics = {}));
//# sourceMappingURL=referral.js.map